import React from 'react';
import { Icon } from './Icon.js';
export const IconArchive = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("path", { d: "m14,2H6c-2.206,0-4,1.794-4,4v8c0,2.206,1.794,4,4,4h8c2.206,0,4-1.794,4-4V6c0-2.206-1.794-4-4-4Zm2,11c0,.552-.448,1-1,1h-1.719c-.459,0-.859.312-.97.757l-.121.485c-.111.445-.511.757-.97.757h-2.438c-.459,0-.859-.312-.97-.757l-.121-.485c-.111-.445-.511-.757-.97-.757h-1.719c-.552,0-1-.448-1-1v-7c0-1.105.895-2,2-2h8c1.105,0,2,.895,2,2v7Z", strokeWidth: "0", fill: "currentColor" })));
};
//# sourceMappingURL=IconArchive.js.map